import React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Grid,
} from "@mui/material";

const defaultSelectMenuProps = (menuMinWidth) => ({
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
  PaperProps: {
    sx: {
      minWidth: menuMinWidth ?? 280,
      maxHeight: 320,
      mt: 0.5,
      boxShadow: (theme) => theme.shadows[8],
    },
  },
});

export default function SuperAdminLocationSelects({
  countryOptions,
  stateOptions,
  cityOptions,
  venueOptions = [],
  countryId,
  stateId,
  cityId,
  venueId,
  onCountryChange,
  onStateChange,
  onCityChange,
  onVenueChange,
  loadingCountries,
  loadingStates,
  loadingCities,
  loadingVenues = false,
  size = "small",
  itemProps = { xs: 12, sm: 6, md: 3 },
  menuMinWidth = 280,
  formControlSx = {},
  locationLocked = false,
  lockedScope = null,
  hideCity = false,
  hideVenue = false,
  includeVenue = true,
}) {
  const menuProps = defaultSelectMenuProps(menuMinWidth);
  const fcSx = {
    minWidth: { xs: "100%", sm: 200, md: 220 },
    width: "100%",
    ...formControlSx,
  };
  const showVenue = includeVenue && !hideVenue;

  if (locationLocked && lockedScope) {
    const rows = [
      { label: "Country", value: lockedScope.country },
      { label: "State", value: lockedScope.state },
      { label: "City", value: lockedScope.city },
    ].filter((r) => r.value);
    return rows.map((row) => (
      <Grid item {...itemProps} key={row.label}>
        <FormControl fullWidth size={size} sx={fcSx}>
          <InputLabel shrink>{row.label}</InputLabel>
          <Select label={row.label} value={row.value} disabled notched displayEmpty>
            <MenuItem value={row.value}>{row.value}</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    ));
  }

  return (
    <>
      <Grid item {...itemProps}>
        <FormControl fullWidth size={size} sx={fcSx}>
          <InputLabel id="sa-country" shrink>
            Country
          </InputLabel>
          <Select
            labelId="sa-country"
            label="Country"
            value={countryId || ""}
            onChange={(e) => onCountryChange(e.target.value)}
            disabled={loadingCountries}
            displayEmpty
            notched
            MenuProps={menuProps}
          >
            <MenuItem value="">
              <em>All</em>
            </MenuItem>
            {countryOptions.map((o) => (
              <MenuItem key={o.id} value={String(o.value)}>
                {o.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item {...itemProps}>
        <FormControl fullWidth size={size} sx={fcSx}>
          <InputLabel id="sa-state" shrink>
            State
          </InputLabel>
          <Select
            labelId="sa-state"
            label="State"
            value={stateId || ""}
            onChange={(e) => onStateChange(e.target.value)}
            disabled={!countryId || loadingStates}
            displayEmpty
            notched
            MenuProps={menuProps}
          >
            <MenuItem value="">
              <em>All</em>
            </MenuItem>
            {stateOptions.map((o) => (
              <MenuItem key={o.id} value={String(o.value)}>
                {o.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      {!hideCity ? (
        <Grid item {...itemProps}>
          <FormControl fullWidth size={size} sx={fcSx}>
            <InputLabel id="sa-city" shrink>
              City
            </InputLabel>
            <Select
              labelId="sa-city"
              label="City"
              value={cityId || ""}
              onChange={(e) => onCityChange(e.target.value)}
              disabled={!stateId || loadingCities}
              displayEmpty
              notched
              MenuProps={menuProps}
            >
              <MenuItem value="">
                <em>All</em>
              </MenuItem>
              {cityOptions.map((o) => (
                <MenuItem key={o.id} value={String(o.value)}>
                  {o.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      ) : null}
      {showVenue ? (
        <Grid item {...itemProps}>
          <FormControl fullWidth size={size} sx={fcSx}>
            <InputLabel id="sa-venue" shrink>
              Venue
            </InputLabel>
            <Select
              labelId="sa-venue"
              label="Venue"
              value={venueId || ""}
              onChange={(e) => onVenueChange(e.target.value)}
              disabled={!cityId || loadingVenues}
              displayEmpty
              notched
              MenuProps={menuProps}
            >
              <MenuItem value="">
                <em>All Venues</em>
              </MenuItem>
              {venueOptions.map((o) => (
                <MenuItem key={o.id} value={String(o.value)}>
                  {o.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      ) : null}
    </>
  );
}
